export const DIAMOND_TYPES = {
  ALL: 'all',
  WHITE: 'whiteDiamond',
  FANCY: 'fancyColorDiamond',
  MOST_DISCOUNTED_DIAMOND: 'mostDiscountedDiamond',
}

export const DIAMOND_BIN_TYPES = {
  ACTIVE: 'active',
  SKIPPED: 'skipped',
}

export const SHOPIFY_CART_DIAMONDS_RESPONSE_TYPE = {
  ACTIVE: 'active',
  OUT_OF_STOCK: 'outOfStock',
}

export const DIAMOND_API_NAME = {
  SRD: 'srd',
  NAROLA: 'narola',
  HK: 'hk',
  PROLANCE_IT: 'prolanceIt',
  VENUS: 'venus',
}

export const DIAMOND_API_DISPLAY_NAMES = {
  [DIAMOND_API_NAME.HK]: 'HK',
  [DIAMOND_API_NAME.NAROLA]: 'NAROLA',
  [DIAMOND_API_NAME.SRD]: 'SRD',
  [DIAMOND_API_NAME.PROLANCE_IT]: 'PROLANCE IT',
  [DIAMOND_API_NAME.VENUS]: 'VENUS',
}

export const DIAMOND_SUPPLIER_LIST = Object.entries(DIAMOND_API_NAME).map(
  ([key, value]) => ({
    key,
    value,
    label: DIAMOND_API_DISPLAY_NAMES[value] || key,
  }),
)

export const DiamondFilterOptionTypes = {
  SHAPE: 'shape',
  CARAT: 'carat',
  COLOR: 'color',
  CLARITY: 'clarity',
  FLUORESCENCE: 'fluorescence',
  MILKY: 'milky',
  COLOR_SHADE: 'colorShade',
  LAB: 'lab',
  CUT: 'cut',
  POLISH: 'polish',
  SYMMETRY: 'symmetry',
  FANCY_COLORS: 'fancyColors',
  INTENSITY: 'intensity',
  OVERTONE: 'overtone',
  KEY_TO_SYMBOL: 'keyToSymbol',
}

export const DIAMOND_LOGS_RESPONSE = {
  OK: 'ok',
  ERROR: 'error',
}

export const DiamondFilterOptionValueType = {
  ALL: 'all',
  VALUE: 'value',
  OTHER: 'other',
}

export const GraphType = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
}
